import Link from 'next/link';

import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';

let counter = 185155; // hhmmss
const getTrackerCls = (topic: string) => `tracker-text-collection-shirts_${topic}-230601-${counter++}`;

const links = {
  'dress-shirt': (
    <Link href="/blog/how-to-wear-cufflinks" replace={true} className={getTrackerCls('dress_shirt')}>
      {'dress shirts'}
    </Link>
  ),
  range: (
    <Link href="/swatch/build?swatches=" replace={true} className={getTrackerCls('range_of_colors')}>
      {'range of colors'}
    </Link>
  ),
  'suit-tux': (
    <Link href="/collection/tuxedos-and-suits" replace={true} className={getTrackerCls('suit_or_tux')}>
      {'suit or tuxedo'}
    </Link>
  ),
  plaid: (
    <Link href="/collection/shirts?pattern=Plaid" replace={true} className={getTrackerCls('plaid')}>
      {'plaid'}
    </Link>
  ),
  gingham: (
    <Link href="/collection/shirts?pattern=Gingham" replace={true} className={getTrackerCls('gingham')}>
      {'gingham'}
    </Link>
  ),
};

const ShirtsCopy = () => (
  <>
    <Layout1x1 data-testid="shirts-section">
      <h3 className="text-h2">{'About Our Shirts'}</h3>
      <Line />
      <p>
        Whether you’re looking for something for a wedding, a black-tie event, or even for work, Generation Tux’s {links['dress-shirt']} are
        the perfect choice for your suit or tuxedo. Made from high quality materials, these dress shirts are designed for you to feel
        comfortable while still looking sharp. In a variety of styles and sizes, you’ll find the perfect shirt to pair with your suit or
        tuxedo.
      </p>
    </Layout1x1>

    <Layout1x1 data-testid="shirts-section" className="mt-56">
      <h3 className="text-h2">{'Shirt Colors'}</h3>
      <p>
        Available in a {links.range}, including black, white, pink, and blue, these shirts are a perfect match for any formal occasion. Our
        black and white dress shirts are classic and versatile, sure to pair well with any {links['suit-tux']}. Add a bit of fun with our
        pink and blue dress shirts, perfect for making a bold statement at a wedding or gala.
      </p>
    </Layout1x1>

    <Layout1x1 data-testid="shirts-section" className="mt-56">
      <h3 className="text-h2">{'Shirt Patterns'}</h3>
      <p>
        Choose from a variety of patterns including solid, {links.plaid}, check, and {links.gingham} shirts. Our solid dress shirts provide
        a sleek and professional look, while our plaid, check, and gingham patterns add a touch of personality to your formalwear.
      </p>
    </Layout1x1>
  </>
);

export default ShirtsCopy;
